<script setup lang="ts">
import UiAppHeader from './UiAppHeader.vue';
import UiScreen from './UiScreen.vue';

/**
 * A full screen of the app: `UiScreen` (canvas and glow) with `UiAppHeader`
 * (the page's `<h1>`, `leading` and `trailing` slots) and the content in
 * `<main>`, inset by the 24px gutter and clear of the home indicator.
 * Figma: OMB Kit › App Header (the header it draws).
 */
const props = defineProps<{
  title?: string;
}>();

const slots = defineSlots<{
  default?: () => unknown;
  leading?: () => unknown;
  trailing?: () => unknown;
}>();
</script>

<template>
  <UiScreen>
    <template #header>
      <UiAppHeader :title="props.title">
        <template
          v-if="slots.leading"
          #leading
        >
          <slot name="leading" />
        </template>
        <template
          v-if="slots.trailing"
          #trailing
        >
          <slot name="trailing" />
        </template>
      </UiAppHeader>
    </template>
    <main class="mx-auto flex w-full max-w-2xl flex-1 flex-col px-gutter pt-4 pb-safe-offset-8">
      <slot />
    </main>
  </UiScreen>
</template>
